import type BookingService from 'bookings-shared/lib/c1/schema/BookingService';
import type MeetingTypeEditOptionState from '../store/schema/MeetingTypeEditOptionState';
import store from '../store/Store';

export default function hasSharedLinkB2(
    meetingType: BookingService | MeetingTypeEditOptionState | undefined | null,
    excludeFromSelfService: boolean | undefined
): boolean {
    // If no meeting type extension, then no share link has been generated
    if (!meetingType) {
        return false;
    }

    // if store.linkGeneratedServices contains meetingType.Id, then share link has been generated
    if (store.linkGeneratedServiceIds?.includes((meetingType as BookingService)?.ServiceId ?? '')) {
        return true;
    }

    const hasBookingUrlCode = meetingType?.bookingUrlCodes?.length != 0;

    const meetingTypeHasSharedLink = hasBookingUrlCode && !excludeFromSelfService;

    return meetingTypeHasSharedLink;
}
